module.exports = __webpack_public_path__ + "static/img/qbtzj.cfc2c08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/qbtzj.png
// module id = GYa9
// module chunks = 0